import React, { useEffect, useRef, useState } from "react";
import DiaglogBox from "../../atoms/DiaglogBox";
import Button from "../../atoms/Button";
import toast from "react-hot-toast";
import { Form, Input, Select } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthContext } from "../../../context/AuthContext";
import { LoadingOutlined } from "@ant-design/icons";
import {
  createRegistryDetails,
  updateRegistryDetails,
} from "../../../utils/api/offset-details";
// import Select from "antd";

const inputClass = "border-0 border-b-2 rounded-none";
const { Option } = Select;

const CreateRegistry = ({ open, onOk, onCancel, registryData, registries }) => {
  const [form] = Form.useForm();
  const { setAuthUser } = useAuthContext();
  const queryClient = useQueryClient();
  const [previousRegistry, setPreviousRegistry] = useState([]);
  const [currentRegistryId, setCurrentRegistryId] = useState(null);
  const [shortName, setShortName] = useState("");
  const [registryImage, setRegistryImage] = useState("");
  const [registryExist, setRegistryExist] = useState(false);
  // const [disabled, setDisabled] = useState(false);
  const [otherRegistry, setOtherRegistry] = useState(false);
  const parentRef = useRef(null);

  useEffect(() => {
    if (registries) {
      setPreviousRegistry(
        registries.map((registry) => ({
          value: registry.registryName, // Display registry name in dropdown
          label: registry.registryName, // Label shown in dropdown
          registryData: registry, // Store the full registry data
        }))
      );
    }
    if (registryData) {
      form.setFieldsValue({
        registryName: registryData.registryName,
        registryID: registryData.registryID,
        registryUserName: registryData.registryUserName,
      });
    }
    setOtherRegistry(false);
  }, [registryData, registries, form, open]);

  useEffect(() => {
    if (parentRef && parentRef.current) {
      parentRef.current.scrollTop = 0;
    }
  }, [open]);
  const { mutate: editHandler, isLoading: editLoader } = useMutation({
    mutationFn: async (data) => {
      try {
        const response = await updateRegistryDetails(
          registryData._id,
          data,
          setAuthUser
        );
        return response;
      } catch (error) {
        console.error("Mutation Error:", error);
        throw error;
      }
    },
    onSuccess: (data) => {
      form.resetFields();
      toast.success("Registry Details updated");
      queryClient.invalidateQueries(["RegistryDetails"]);
      onOk();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: async (data) => {
      try {
        return await createRegistryDetails(
          { id: currentRegistryId, registryData: data },
          setAuthUser
        );
      } catch (error) {
        throw error;
      }
    },
    onSuccess: (data) => {
      form.resetFields();
      toast.success("Registry Details created");
      queryClient.invalidateQueries(["RegistryDetails"]);
      onOk();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const onFinish = (data) => {
    // console.log("Exist", registryExist)
    if (registryExist === true) {
      toast.error("Registry Already Exiisted");
    } else {
      let modifiedData = { ...data };

      if (otherRegistry) {
        modifiedData.registryName = data.registryUserName;
        modifiedData.shortName = shortName;
        modifiedData.Image = registryImage;
      }

      // Handle edit or create logic
      if (registryData) {
        editHandler(modifiedData); // Edit case
      } else {
        mutate(modifiedData);
        modifiedData.shortName = shortName;
        modifiedData.Image = registryImage; // Create case
      }
    }
  };

  return (
    <DiaglogBox
      open={open}
      onCancel={() => {
        form.resetFields();
        setOtherRegistry(false);
        onCancel();
      }}
      width={617}
      height={600}
    >
      <div
        className="px-6 max-h-96 overflow-auto no-scrollbar py-4"
        ref={parentRef}
      >
        <h3 className="text-[1.75rem] pb-2 font-bold text-black">
          {registryData ? "Edit Registry" : "Add Another Registry"}
        </h3>
        <Form
          form={form}
          onFinish={onFinish}
          noValidate
          className="offset-form font-spaceGrotesk"
        >
          <div className="flex gap-x-8">
            {/* <Form.Item
              label="Registry Name"
              className="w-[calc(30%)] mr-6 text-black-400"
              name="registryName"
              rules={[
                {
                  required: true,
                  message: "Please enter Registry Name",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            > */}
            {/* <Input className={inputClass} /> */}

            {/* </Form.Item> */}
            <Form.Item
              label="Registry Name"
              className="w-[calc(30%)] mr-6 text-black-400"
              name="registryName"
              rules={[
                {
                  required: true,
                  message: "Please select a Registry",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Select
                className="primary_variant"
                options={[
                  ...previousRegistry,
                ]}
                placeholder="Select Registry"
                onChange={(value, option) => {
                  const { registryData } = option;
                  setCurrentRegistryId(registryData._id);
                  setShortName(registryData.shortName);
                  setRegistryImage(registryData.image);
                  setRegistryExist(registryData.registryExists);
                  if (value === "Others") {
                    form.setFieldsValue({
                      registryID: "",
                      registryUserName: "",
                    });
                    setOtherRegistry(true);
                    // setDisabled(false); // Enable the input fields
                  } else {
                    form.setFieldsValue({
                      registryID: registryData.registryID || "",
                      registryUserName: registryData.registryUserName || "",
                    });
                    setOtherRegistry(false);
                    // setDisabled(true); // Disable the input fields
                  }
                }}
              />
            </Form.Item>
            <Form.Item
              label="Reg ID"
              className="font-normal w-1/2"
              name="registryID"
              rules={[
                {
                  required: true,
                  message: "Please enter ID",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input
                className={inputClass}
                // disabled={disabled}
              />
            </Form.Item>
          </div>
          <hr />
          <div className="flex gap-10">
            {otherRegistry && (
              <Form.Item
                label="Others Registry Name"
                className="font-normal w-2/5"
                name="othersRegistryName"
                rules={[
                  {
                    required: true,
                    message: "Please enter Registry Name",
                  },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input
                  className={inputClass}
                  // disabled={disabled}
                />
              </Form.Item>
            )}
            <Form.Item
              label="User Name"
              className="font-normal w-2/5"
              name="registryUserName"
              rules={[
                {
                  required: true,
                  message: "Please enter User Name",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input
                className={inputClass}
                // disabled={disabled}
              />
            </Form.Item>
          </div>
          <hr />

          <div className="flex gap-x-4 mt-4">
            <Button
              className={"w-1/2 py-2 text-white font-bold"}
              color={"blue"}
              varient={"primary"}
              type="submit"
            >
              {isLoading || editLoader ? (
                <LoadingOutlined />
              ) : registryData ? (
                "Save"
              ) : (
                "Submit"
              )}
            </Button>

            <Button
              onClick={() => {
                form.resetFields();
                onCancel();
                setOtherRegistry(false);
              }}
              className={
                "w-1/2 py-2 bg-blue-400 font-bold text-blue-800 border-[1px] "
              }
              varient={"primary"}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    </DiaglogBox>
  );
};

export default CreateRegistry;
